import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import ScoreLookup from './ScoreLookup';

export default function AdminScoreLookup() {
  return (
    <Box>
      <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
        <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.main' }}>
          🔍 Score Lookup
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Look up results by USFS membership ID (admin only).
        </Typography>
      </Paper>
      <Paper elevation={2} sx={{ p: 3 }}>
        <ScoreLookup />
      </Paper>
    </Box>
  );
}
